// extracted by mini-css-extract-plugin
export default {"mainWrapper":"SLCPreviewJobDetailsAndDescription_mainWrapper__N5XNF"};